import webBackApi from '../../api/webBackApi';

export const getCustomerNotes = async (customerId) => {
  try {
    const response = await webBackApi.get(`/api/customer-notes/${customerId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer notes:", error);
    throw error;
  }
};

export const createCustomerNote = async (customerId, note) => {
  try {
    const response = await webBackApi.post('/api/customer-notes', { customerId, note });
    return response.data;
  } catch (error) {
    console.error("Error creating customer note:", error);
    throw error;
  }
};
